module.exports = __webpack_public_path__ + "img/titile_bg_sy.c4192ca7.png";